<template>
  <div class="row m-0 justify-content-end">
    <div class="col-auto pr-0 pointer" @click="toggleOpen">
      <div class="row m-0 align-items-center">
        <div class="col px-1 pb-1 truncate_1">
          {{ shopId }}
          <!-- {{user.name}} -->
        </div>
        <div class="col-auto p-0 small" >
          <span class="material-icons" :class="{'oneeighty_degree': isOpen}">
            expand_more
          </span>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="menu_dropdown py-3" v-if="isOpen">
        <div class="row m-0">
          <div class="col-12 mb-2 truncate_1 pointer" v-for="shop in shopIds" :key="shop" @click="openShop(shop)">
            {{ shop }}
          </div>
        </div>
        <div class="row m-0 border-top pointer" @click="addNew">
          <div class="col-auto pr-1 mt-2">
            <span class="material-icons">add_circle_outline</span>
          </div>
          <div class="col py-2 pl-0">
            New Shop
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: ['user'],
  data () {
    return {
      isOpen: false
    }
  },
  created () {
    window.addEventListener('click', this.close)
  },

  beforeDestroy () {
    window.removeEventListener('click', this.close)
  },
  computed: {
    ...mapGetters(['shopIds', 'shopId'])
  },
  methods: {
    ...mapActions(['logout', 'initializeShop']),
    toggleOpen () {
      this.isOpen = !this.isOpen
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false
      }
    },
    openShop (shopId) {
      this.isOpen = false
      this.initializeShop(shopId)
      this.$router.push('/')
    },
    addNew () {
      this.isOpen = false
      this.$router.push({ name: 'newshop' })
    }
  }
}
</script>

<style scoped>
  .menu_dropdown {
    position: absolute;
    top: 40px;
    right: 0;
    width: inherit;
    background-color: var(--light-color-off);
  }
  .dark-mode .menu_dropdown {
    background-color: var(--dark-color);
  }
  .oneeighty_degree {
    transform: rotate(180deg);
  }
</style>
